import { ITermosUsoRepository } from '../repositories/ITermosUsoRepository'

export interface IFind {
  execute(): Promise<string>
}

export default class IFindImpl implements IFind {
  constructor(private readonly termosUsoRepository: ITermosUsoRepository) {}

  public async execute(): Promise<string> {
    const response = await this.termosUsoRepository.find()

    return response
  }
}
